import { render } from "./APIKeys.vue?vue&type=template&id=0061a8be"
import script from "./APIKeys.vue?vue&type=script&lang=js"
export * from "./APIKeys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__